import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MATERIAL_IMPORTS } from '../../../material/material-imports';
import { CapitalizePipe } from '../../../shared/pipes/capitalize.pipe';
import { Location } from '@angular/common';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { FormGroup, Validators } from '@angular/forms';
import { FormService } from '../../../shared/form.service';
import { AlertService } from '../../../core/alert/alert.service';
import { TopicService } from '../topic.service';
import {SubjectModel, TopicModel, TopicRequest} from '@generativ/much-smarter-models';
import { Observable } from 'rxjs';
import { SubjectService } from '../../../shared/subject.service';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ...MATERIAL_IMPORTS, CapitalizePipe],
  selector: 'app-topic',
  templateUrl: './topic.component.html',
  styleUrls: ['./topic.component.scss']
})
export class TopicComponent implements OnInit {

  topicId: number;
  topicForm: FormGroup;
  pageType: string;
  tiers1: Observable<string[]>;
  subjects: SubjectModel[];
  errorMessage: string;
  isSubmitting = false;

  constructor(private route: ActivatedRoute,
              private router: Router,
              public formService: FormService,
              private topicService: TopicService,
              private alertService: AlertService,
              private location: Location,
              private subjectService: SubjectService) {
    this.topicForm = this.formService.createForm(this.formOptions);
  }

  ngOnInit() {
    this.route.data.subscribe((data) => {
      this.pageType = data.type;
      this.subjectService.getSubjects().subscribe(
        subjects => {
          this.subjects = subjects;
        }
      );
      if (this.pageType === 'edit') {
        this.route.params.subscribe((params: Params) => {
          this.topicId = +params['topicId'];
          this.topicService.getTopic(this.topicId).subscribe(
            topicModel => {
              console.log('topic model', topicModel);
              this.topicForm.patchValue(topicModel);
            }
          );
        });
        this.topicForm.get('tier1').disable();
        this.topicForm.get('tier2').disable();
        this.topicForm.get('tier3').disable();
        this.topicForm.get('tier4').disable();
      }
    });
  }

  submitForm() {
    if (this.formService.validateFormAndUpdateErrors(this.topicForm)) {
      let topicObservable: Observable<TopicModel>;
      let message: string;
      this.errorMessage = null;

      if (this.isSubmitting) {
        return;
      }

      if (!this.topicForm.valid) {
        this.errorMessage = 'Errors on form. See fields below.';
        return;
      }

      this.isSubmitting = true;

      if (this.pageType === 'create') {
        const topic = new TopicRequest.Create();
        topic.parse(this.topicForm.value);
        message = 'Topic created';
        topicObservable = this.topicService.createTopic(topic);
      } else {
        const topic = new TopicRequest.Update();
        topic.parse(this.topicForm.value);
        message = 'Topic edited successfully';
        topicObservable = this.topicService.updateTopic(this.topicId, topic);
      }
      topicObservable.subscribe(
        topicModel => {
          this.alertService.success(message);
          this.location.back();
        },
        err => {
          this.isSubmitting = false;
          this.alertService.error(err);
        }
      );
    }
  }

  get buttonName(): string {
    return this.pageType === 'edit' ? 'SAVE' : this.pageType.toUpperCase();
  }

  private  get formOptions(): object {
    return {
      'displayName': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(100)
        ])
      ],
      'subject': [
        null,
        Validators.compose([
          Validators.required
        ])
      ],
      'tier1': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(100)
        ])
      ],
      'tier2': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(100)
        ])
      ],
      'tier3': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(100)
        ])
      ],
      'tier4': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(100)
        ])
      ],
      'strategyName': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(100)
        ])
      ]
    };
  }
}
